import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const contactDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/contacts/$contactId",
  component: lazyRouteComponent(() => import("./contact-detail.page.js"), "ContactDetailPage"),
});
